<template>
  <modal
    v-if="isVisible"
    elem-id="modal_translations_admin"
    modal-size="modal-md"
    :title="modalTitle"
    :show="isVisible"
    @close="closeModal"
    @dismiss="closeModal"
  >
    <template v-if="isVisible">
      <translations-form
        :paginas="paginas"
        :pagina="pagina"
        :item="editingItem"
        :idioma="idioma"
        @save-success="handleSaveSuccess"
      />
    </template>
  </modal>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../eventBus'
import { log } from '../../utils/DebugLogger'
import type { Traducoes_ItemRow } from '../../contracts/Traducoes_ItemRow'
import type { Traducoes_PaginaRow } from '../../contracts/Traducoes_PaginaRow'

/**
 * The open payload. This modal is mounted once by ModalManager, outside the
 * page's component tree, so the catalog it needs (the page list) travels on the
 * event instead of on props — it has no composable of its own.
 */
interface OpenPayload {
  item?: Traducoes_ItemRow | null
  paginas?: Traducoes_PaginaRow[]
  pagina?: string
  idioma?: string
}

const { t } = useI18n()
const isVisible = ref<boolean>(false)
const editingItem = ref<Traducoes_ItemRow | null>(null)
const paginas = ref<Traducoes_PaginaRow[]>([])
const pagina = ref<string>('')
const idioma = ref<string>('')

const modalTitle = computed<string>(() =>
  editingItem.value ? t('Editar tradução') : t('Criar chave de tradução'),
)

const closeModal = (): void => {
  isVisible.value = false
  editingItem.value = null
}

const handleSaveSuccess = (): void => {
  log('TranslationsModal', 'handleSaveSuccess', 'Formulário salvo')
  closeModal()
  eventBus.emit('translationsAdmin.created')
}

const handleOpen = (payload?: OpenPayload): void => {
  log('TranslationsModal', 'handleOpen', 'Abrindo modal', payload)
  editingItem.value = payload?.item ?? null
  paginas.value = payload?.paginas ?? []
  pagina.value = payload?.pagina ?? ''
  idioma.value = payload?.idioma ?? ''
  isVisible.value = true
}

onMounted(() => {
  eventBus.on('modal.translationsAdmin.open', handleOpen)
})

onBeforeUnmount(() => {
  eventBus.off('modal.translationsAdmin.open', handleOpen)
})
</script>
